import { useState } from 'react';
import { Route, Routes} from 'react-router-dom';
import { Amplify } from 'aws-amplify';
import awsExports from './aws-exports';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css'
import '@aws-amplify/ui-react/styles.css';
import LoginPage from './components/auth/LoginPage';
import LogoutPage from './components/auth/LogoutPage';
import ForgotPin from './components/forgotPin/ForgotPin.js';
import ConfirmCode from './components/confirmCode/ConfirmCode.js';
import UserList  from './components/userList/UserList.js';
import ChangePassword from './components/changePassword/ChangePassword.js';
import ErrorPage from './components/error/ErrorPage.js';
import InitialLogin from './components/initialLogin/InitialLogin.js';

import enTranslation from './locales/en.json';
import esTranslation from './locales/es.json';
import { I18nextProvider } from 'react-i18next';
import i18n from 'i18next';

Amplify.configure(awsExports);

i18n.init({
  lng: 'es', // Establece el idioma predeterminado
  resources: {
    en: {
      translation: enTranslation // Carga las traducciones en inglés
    },
    es: {
      translation: esTranslation // Carga las traducciones en español
    }
  }
});

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false)

  function updateAuthStatus(authStatus) {
    setIsAuthenticated(authStatus)
  }

  return (
    <I18nextProvider i18n={i18n}>
      <div>
        <Routes>
          <Route path='*' element={<InitialLogin />} />
          <Route path='/' element={<InitialLogin />} />
          <Route path='/logout' element={<LogoutPage updateAuthStatus={updateAuthStatus} />} />
          <Route path='/login/pin' element={<LoginPage updateAuthStatus={updateAuthStatus} />} />
          <Route path='/login/pass' element={<LoginPage updateAuthStatus={updateAuthStatus} />} />
          <Route path='/forgotpin' exact={true} element={<ForgotPin/>} />
          <Route path='/confirmcode' exact={true} element={<ConfirmCode/>} />
          <Route path='/userlist' exact={true} element={<UserList/>} />
          <Route path='/changepassword' exact={true} element={<ChangePassword/>} />
          <Route path='/recover-password' exact={true} element={<ChangePassword/>} />
          <Route path='/error' exact={true} element={<ErrorPage/>} />
        </Routes>
      </div>
    </I18nextProvider>
  );
}

export default App;